<template>
  <div>
    <h1 class="page-header">Category</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-6">
            <ts-button outline color="info" @click="$router.push({ name: 'category-create' })">
              Add New
            </ts-button>
          </div>
          <div class="col-sm-6 d-flex justify-content-end">
            <ts-input v-model="search" placeholder="Search" style="width: 300px;" class="kh-font" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template slot-scope="{ record }">
          <td class="kh-font">{{ record.category_name_kh }}</td>
          <td>{{ record.category_name_en }}</td>
          <td>{{ record.category_rate }}</td>
          <td>{{ record.category_effective_date }}</td>
          <td>{{ record.category_expiry_date }}</td>
          <td class="text-center">
            <router-link
              :to="{
                name: 'category-edit',
                params: { id: record.category_id }
              }"
              title="edit"
              class="mr-2"
            >
              <i class="fas fa-edit"></i>
            </router-link>
            <a href="#" title="delete" class="text-danger" @click="destroy(record.category_id)">
              <i class="fas fa-trash"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <ts-card-wrapper class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData" b> </ts-pagination>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'category',
  data() {
    return {
      loading: false,
      columns: [
        { name: 'name kh' },
        { name: 'name en' },
        { name: 'rate', style: 'width: 10%' },
        { name: 'effective date', style: 'width: 15%' },
        { name: 'expiry date', style: 'width: 15%' },
        { name: 'Action', style: 'width: 1px; text-align:center' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('inventory/category', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.inventory.category.search
      },
      set(newValue) {
        this.$store.commit('inventory/category/SET_SEARCH', newValue)
        this.$store.commit('inventory/category/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('inventory/category/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },

    async destroy(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('inventory/category/deleteCategory', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'category-create') {
      this.$store.commit('inventory/category/RESET_STATE')
    }
    next()
  }
}
</script>
